import { Box } from "@mui/material";
import { CustomInput, CustomSelect } from "../../../components-new/common";
import {
  AssertSubOptions,
  AssertTextOptions,
  CheckBoxOptions,
  DropDownOptions,
  KeywordData,
  AppPermission,
  pressKeyCodeOptions,
} from "../constants";
import { getActionOptions } from "./helper";
import { useDispatch, useSelector } from "react-redux";
import { MOBILE_ONLY_KEYWORDS, COMMON_KEYWORDS } from "../constants";
import { setEditStep } from "../../../Redux/TestAuthoring/TestAuthoring";
import AssertionSetup from "./AssertionSetup";
import TestDataSetup from "./TestDataSetup";
import TestDataProcessing from "./TestDataProcessing";
const ElementDetails = ({ item }) => {
  const dispatch = useDispatch();
const isMobile = useSelector((state) => state.authoringSlice.isMobile);

const filteredKeywordData = KeywordData.filter((k) => {
  if (COMMON_KEYWORDS.includes(k.value)) return true;
  if (isMobile) return MOBILE_ONLY_KEYWORDS.includes(k.value);
  return !MOBILE_ONLY_KEYWORDS.includes(k.value);
});
  const handleChange = (value, field) => {
    if (field === "Keyword") {
    const newOptions = getActionOptions(value);

    dispatch(
      setEditStep({
        ...item,
        Keyword: value,
        Action: newOptions?.[0]?.value || "", 
      })
    );

    return;
  }
    dispatch(setEditStep({ ...item, [field]: value }));
  };

  const actionOptions = getActionOptions(item.Keyword);

  return (
    <Box>
      <Box bgcolor="#E2E6F3" p="20px" borderRadius="13px" mb={3}>
        <Box display="flex" columnGap={3}>
          <Box mb={3} flex={1}>
            <CustomSelect
              label={"Element"}
              options={(item.Step_Number === 0
  ? filteredKeywordData.filter((k) => k.value === "Url" || k.value === "Inline")
  : filteredKeywordData
)
  .slice()
  .sort((a, b) => a.value.localeCompare(b.value))}
              width={"100%"}
              background={"#ffffff"}
              value={
                item.Step_Number === 0
                  ? item.Keyword === "Inline"
                    ? "Inline"
                    : "Url"
                  : item.Keyword === "Validation"
                    ? "Assertion"
                    : item?.Keyword
              }
              onChange={(e) => handleChange(e.target.value, "Keyword")}
            />
          </Box>
          <Box flex={1}>
            <CustomSelect
              label={"Action"}
              options={actionOptions}
              width={"100%"}
              background={"#ffffff"}
              value={
                item.Action ||
                (actionOptions?.length ? actionOptions[0].value : "")
              }
              onChange={(e) => handleChange(e.target.value, "Action")}
            />
          </Box>
          {item.Keyword === "Assertion" && item.Action === "Properties" && (
            <Box flex={1}>
              <CustomSelect
                label={"Options"}
                options={AssertSubOptions}
                width={"100%"}
                background={"#ffffff"}
                value={item.subAction || "validatePartial"}
                onChange={(e) => handleChange(e.target.value, "subAction")}
              />
            </Box>
          )}
          {(item.Keyword === "Assertion" || item.Keyword === "Validation") &&
            item.Action === "validatePartial" && (
              <Box flex={1}>
                <CustomSelect
                  label={"Options"}
                  options={AssertTextOptions}
                  width={"100%"}
                  background={"#ffffff"}
                  value={item.subAction || "validatePartial"}
                  onChange={(e) => handleChange(e.target.value, "subAction")}
                />
              </Box>
            )}
          {item.Keyword === "mobilePermission" &&
            (item.Action === "location" ||
              item.Action === "storage" ||
              item.Action === "mobiledata" ||
              item.Action === "mobilebluetooth" ||
              item.Action === "airplanemode" ||
              item.Action === "mobilehotspot" ||
              item.Action === "mobilewifi") && (
              <Box flex={1}>
                <CustomSelect
                  label={"Permission"}
                  options={AppPermission}
                  width={"100%"}
                  background={"#ffffff"}
                  value={item.subAction || "validatePartial"}
                  onChange={(e) => handleChange(e.target.value, "subAction")}
                />
              </Box>
            )}

          {item.Keyword === "Assertion" && item.Action === "expression" && (
            <Box flex={1}>
              <CustomInput
                labelinput={"Assertion Expression"}
                placeholder={"Enter assertion expression"}
                value={item.assertionExpression}
                onChange={(e) => handleChange(e.target.value, "assertionExpression")}
                multiline
                rows={4}
                inputProps={{ maxLength: 1000 }}
              />
            </Box>
          )}
          {item.Keyword === "visualAnalysis" && item.Action === "visionAI" && (
            <Box flex={1}>
              <CustomInput
                labelinput={"Vision AI Prompt"}
                placeholder={"Enter what you would like to compare"}
                value={item.assertionExpression}
                onChange={(e) => handleChange(e.target.value, "assertionExpression")}
                multiline
                rows={4}
                inputProps={{ maxLength: 2000 }}
              />
            </Box>
          )}
          {item.Keyword === "DropDown" && item.Action === "Select" && (
            <Box flex={1}>
              <CustomSelect
                label={"Options"}
                options={DropDownOptions}
                width={"100%"}
                background={"#ffffff"}
                value={item.subAction}
                onChange={(e) => handleChange(e.target.value, "subAction")}
              />
            </Box>
          )}
          {item.Keyword === "mobile" && item.Action === "pressKeyCode" && (
            <Box flex={1}>
              <CustomSelect
                label={"Options"}
                options={pressKeyCodeOptions}
                width={"100%"}
                background={"#ffffff"}
                value={item.subAction}
                onChange={(e) => handleChange(e.target.value, "subAction")}
              />
            </Box>
          )}
          {item.Keyword === "Check Box" && item.Action === "Checkbox" && (
            <Box flex={1}>
              <CustomSelect
                label={"Options"}
                options={CheckBoxOptions}
                width={"100%"}
                background={"#ffffff"}
                value={item.subAction}
                onChange={(e) => handleChange(e.target.value, "subAction")}
              />
            </Box>
          )}
          {item.Keyword === "Alert" && item.Action === "Alert" && (
            <Box flex={1}>
              <CustomSelect
                label={"Options"}
                options={AssertTextOptions}
                width={"100%"}
                background={"#ffffff"}
                value={item.subAction}
                onChange={(e) => handleChange(e.target.value, "subAction")}
              />
            </Box>
          )}
          {item.Keyword === "conditionalLogic" && item.Action === "forStart" && (
            <Box flex={1}>
              <CustomInput
                labelinput={"For Loop Initialization"}
                placeholder={"Enter for loop initialization"}
                value={item.initialization}
                onChange={(e) => handleChange(e.target.value, "initialization")}
                multiline
                rows={4}
                inputProps={{ maxLength: 1000 }}
              />

              <CustomInput
                labelinput={"Step Increment Expression"}
                placeholder={"Enter step increment expression"}
                value={item.stepExpression}
                onChange={(e) => handleChange(e.target.value, "stepExpression")}
                multiline
                rows={4}
                inputProps={{ maxLength: 1000 }}
              />
              <CustomInput
                labelinput={"Terminate Condition"}
                placeholder={"Enter terminate condition"}
                value={item.terminateCondition}
                onChange={(e) => handleChange(e.target.value, "terminateCondition")}
                multiline
                rows={4}
                inputProps={{ maxLength: 1000 }}
              />
            </Box>
          )}

          {item.Keyword === "conditionalLogic" && item.Action === "ifStart" && (
            <Box flex={1}>
              <CustomInput
                labelinput={"If Condition"}
                placeholder={"Enter if condition"}
                value={item.ifCondition}
                onChange={(e) => handleChange(e.target.value, "ifCondition")}
                multiline
                rows={4}
                inputProps={{ maxLength: 1000 }}
              />
            </Box>
          )}
        </Box>
      </Box>
      <Box display="flex" gap={2} flexDirection={"row"}>
        <Box width={{ xs: "100%", md: "60%" }}>
          {(item.Keyword === "Assertion" || item.Keyword === "Validation") && (
            <AssertionSetup item={item} />
          )}
          {item.Keyword !== "Assertion" && item.Keyword !== "Validation" && (
            <TestDataSetup item={item} />
          )}
        </Box>
        <Box width={{ xs: "100%", md: "40%" }}>
          <TestDataProcessing item={item} />
        </Box>
      </Box>
    </Box>
  );
};

export default ElementDetails;